module.exports = __webpack_public_path__ + "static/media/history.1cd8b3f0.png";